import { useTranslation } from 'react-i18next';

export function Header() {
  const { t } = useTranslation('label-perf');

  return (
    <header className="items-center gap-md">
      <h1 className="text-headline-sm font-bold">{t('header.title')}</h1>
    </header>
  );
}

Header.displayName = 'Header';
